// @ts-nocheck
const t = (s, d) => {
  for (const p in d) {
    // eslint-disable-line
    s = s.replace(new RegExp('{' + p + '}', 'g'), d[p]); // eslint-disable-line
  }

  return s;
};

export const PATTERNS = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i,
  USERNAME: /^[a-z][a-z0-9._]*$/i,
};

export const isEmail = (
  msg = 'Ingresa una dirección de correo válida',
) => value => {
  if (value && !PATTERNS.EMAIL.test(value)) {
    return msg;
  }
  return undefined;
};

export const isRequired = (msg = 'Campo Requerido') => val => {
  if (!val) {
    return msg;
  }
  return null;
};

export const customValidation = (pattern, msg) => val => {
  if (val && !pattern.test(val)) {
    return msg;
  }
  return undefined;
};

export const length = ({
  min,
  max,
  field,
  msg = 'El campo {field} debe tener entre {min} y {max} caracteres',
}) => val => {
  if (!val) {
    return null;
  }
  if (val.length < min || val.length > max) {
    return t(msg, { field, min, max });
  }
  return null;
};

export const matchPassword = (matchName, msg) => (value, allValues) => {
  if (value !== allValues[matchName]) {
    return msg;
  }
  return null;
};
